module.exports = __webpack_public_path__ + "img/xytl.abc2ecce.jpg";